export default __webpack_public_path__ + "static/media/profile-card-component.b1d00b3a.png";